<template>
  <div>
    <li v-show="isStaff"><router-link :to="{name: 'Analytics'}">管理ページへ</router-link></li>
    <li><router-link :to="{name: 'ShiftIndex', params: {year: year, month: month}}">シフト一覧ページへ</router-link></li>
    <li><router-link :to="{name: 'ShiftSummary', params: {year: year, month: month}}">シフトSummaryページへ</router-link></li>
    <li><router-link :to="{name: 'ShiftPlanIndex', params: {year: nextYear, month: nextMonth}}">シフト予定入力ページへ</router-link></li>
    <li v-show="isStaff"><router-link :to="{name: 'CsvExport'}">csv出力ページへ</router-link></li>
    <ul v-show="false">
      <li
        v-for="shop in shops"
        v-show="shop.shopType === 1"
        @click="moveToDashboard(shop.pk)"
        :key="shop.pk">
        {{ shop.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'Index',
  data () {
    return {
      isLoading: false,
      shops: [],
      year: null,
      month: null,
      nextYear: null,
      nextMonth: null,
    }
  },
  computed: {
    ...mapGetters(['isStaff']),
  },
  created () {
    let tmp = moment()
    this.year = tmp.year()
    this.month = tmp.month() + 1

    tmp = moment().add(1, 'months')
    this.nextYear = tmp.year()
    this.nextMonth = tmp.month() + 1
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.$request.shops.list().then(res => {
        this.shops = res.body.results
      }).finally(() => {
        this.isLoading = false
      })
    },
    moveToDashboard (shopId) {
      const today = moment().locale('ja')
      this.$router.push({
        name: 'Dashboard',
        params: {
          shopId: shopId,
          date: today.format('YYYY-MM-DD'),
        },
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue